export interface CimmpleRxPlan {
  name: string;
  price: string;
  period: string;
  description: string;
  features: string[];
  highlighted: boolean;
  cta: string;
}

/** Single source of truth for CimmpleRx SaaS pricing plans. */
export const cimmpleRxPlans: CimmpleRxPlan[] = [
  {
    name: 'Starter',
    price: '₹799',
    period: '/month',
    description: 'or ₹7,999/year. Best for single pharmacy, 1–3 users.',
    features: [
      'Unlimited billing',
      'Inventory management',
      'GST billing & reports',
      'Batch & expiry management',
      'Purchase management',
      'Cloud backup',
      'Mobile access',
      'Basic AI search & assistance',
      'Email support',
    ],
    highlighted: false,
    cta: 'Get Started',
  },
  {
    name: 'Professional',
    price: '₹1,499',
    period: '/month',
    description: 'or ₹14,999/year.',
    features: [
      'Everything in Starter',
      'AI-powered purchase invoice OCR',
      'AI demand forecasting',
      'AI expiry prediction',
      'WhatsApp billing & communication',
      'Customer loyalty management',
      'Advanced dashboards & analytics',
      'Multi-user support',
      'API integrations',
      'Priority support',
    ],
    highlighted: true,
    cta: 'Get Started',
  },
  {
    name: 'Premium',
    price: '₹2,999',
    period: '/month',
    description: 'or ₹29,999/year.',
    features: [
      'Everything in Professional',
      'Multi-branch management',
      'Centralized inventory',
      'Advanced business analytics',
      'AI business assistant',
      'Supplier intelligence',
      'Dedicated onboarding',
    ],
    highlighted: false,
    cta: 'Get Started',
  },
  {
    name: 'Enterprise',
    price: 'Custom',
    period: 'Pricing',
    description: 'Designed for pharmacy chains and large organizations.',
    features: [
      'Multi-location deployment',
      'Custom integrations',
      'Dedicated account management',
      'SLA & priority support',
    ],
    highlighted: false,
    cta: 'Contact Sales',
  },
];

export const cimmpleRxStartingPrice = 'From ₹799/month';
